import React, { useState, useEffect, useContext , useRef} from 'react';
import axios from 'axios';
import Url from '../Url';
import './Autosend.css';
import { useMemo } from 'react';
import { LoginContext } from '../Login/LoginContext';

export default function Autosend() {
    const { loginResult } = useContext(LoginContext);
    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState('');
    const [whatsappTemplates, setWhatsappTemplates] = useState([]);
    const [loadingWhatsappTemplates, setLoadingWhatsappTemplates] = useState(true);
    const [whatsappTemplateError, setWhatsappTemplateError] = useState(null);
    const [selectedTemplates, setSelectedTemplates] = useState([]);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [activeStatus, setActiveStatus] = useState('All');
    const [sentNumbers, setSentNumbers] = useState([]);
    const [templateTab, setTemplateTab] = useState('All');
    // Offcanvas state
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [offcanvasMsg, setOffcanvasMsg] = useState('');
    const [offcanvasLoading, setOffcanvasLoading] = useState(false);
    const [qrImage, setQrImage] = useState(null);
    const [waReady, setWaReady] = useState(false);
 
    const [qrMessage, setQrMessage] = useState('');
  


    useEffect(() => {
        if (!loginResult) return;
        const fetchData = async () => {
            try {
                const apiUrl = `${Url.Url}/get_report?data=${encodeURIComponent(JSON.stringify({ user_id: loginResult.user_id, report_id: '4' }))}`;
                const response = await fetch(apiUrl);
                const result = await response.json();
                if (Array.isArray(result) && result.length > 0 && Array.isArray(result)) {
                    setData(result);
                    setFilteredData(result);
                    const uniqueStatuses = Array.from(new Set(result.map(item => item.Status || 'No Status')));
                    setStatuses(['All', ...uniqueStatuses]);
                } else {
                    setData([]);
                    setFilteredData([]);
                    setStatuses(['All']);
                }
            } catch {
                setData([]);
                setFilteredData([]);
                setStatuses(['All']);
            }
        };
        fetchData();
    }, [loginResult]);

    useEffect(() => {
        const fetchTemplates = async () => {
            setLoadingWhatsappTemplates(true);
            setWhatsappTemplateError(null);
            try {
                const response = await fetch(`${Url.Url}/get_report?data={"report_id":"13"}`);
                if (!response.ok) throw new Error('Failed to fetch templates');
                const result = await response.json();
                if (Array.isArray(result) && result.length > 0 && Array.isArray(result)) {
                    setWhatsappTemplates(result);
                } else {
                    setWhatsappTemplates([]);
                    setWhatsappTemplateError('No templates found');
                }
            } catch (err) {
                setWhatsappTemplateError('Failed to load templates');
                setWhatsappTemplates([]);
            } finally {
                setLoadingWhatsappTemplates(false);
            }
        };
        fetchTemplates();
    }, []);
    const statusTemplateTabs = useMemo(() => {
        if (!whatsappTemplates.length) return [];
        const unique = Array.from(new Set(whatsappTemplates.map(t => t.status_template)));
        return ['All', ...unique];
    }, [whatsappTemplates]);
    const filteredTemplates = useMemo(() => {
        if (templateTab === 'All') return whatsappTemplates;
        return whatsappTemplates.filter(t => t.status_template === templateTab);
    }, [whatsappTemplates, templateTab]);

    const userId = loginResult?.user_id; // Replace with actual dynamic ID per logged-in user
    // 🔑 F4 opens QR offcanvas
    useEffect(() => {
        const handleKeyDown = async (e) => {
            if (e.key === 'F4') {
                setShowOffcanvas(true);
                setShowQr(true);
                setQrMessage('🟡 Starting WhatsApp...');
                setPolling(true);

                // Start session if not already started
                try {
                    await fetch(`${Url.Url}/start-whatsapp/${userId}`, { method: 'POST' });
                } catch (err) {
                    console.error('❌ Failed to start WhatsApp:', err);
                    setQrMessage('Failed to start WhatsApp session.');
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [userId]);
    
    

    const [polling, setPolling] = useState(false);
    const [showQr, setShowQr] = useState(false);


    // 📲 Fetch QR status
    const fetchQr = async () => {
        try {
            const res = await fetch(`${Url.Url}/whatsapp-qr/${userId}`);
            const data = await res.json();

            console.log('📡 Fetched QR response:', data);

            if (res.status === 404) {
                setQrImage(null);
                setWaReady(false);
                setQrMessage('❌ No session found. Press F4 to start WhatsApp.');
                setPolling(false);
                return;
            }

            if (data.ready) {
                setQrImage(null);
                setWaReady(true);
                setQrMessage('✅ WhatsApp is connected.');
                setPolling(false); // stop polling once connected
            } else if (data.qr) {
                setQrImage(data.qr);
                setWaReady(false);
                setQrMessage('📲 Scan this QR code using WhatsApp on your phone.');
            } else if (data.message) {
                setQrImage(null);
                setWaReady(false);
                setQrMessage(`ℹ️ ${data.message}`);
            }
        } catch (error) {
            console.error('❌ Failed to fetch QR:', error);
            setQrImage(null);
            setWaReady(false);
            setQrMessage('🚫 Server error. Please check your internet or backend.');
            setPolling(false);
        }
    };
    
    
    

    // ⏱ Poll QR every 5 seconds when polling is active
    useEffect(() => {
        if (!polling || !userId) return;

        // Immediately fetch once
        fetchQr();

        // Start polling every 5 seconds
        const interval = setInterval(() => {
            fetchQr();
        }, 5000);

        // Clear on unmount or polling off
        return () => clearInterval(interval);
    }, [polling, userId]);
    
    

  
    // 🔄 Manual reset and show QR again
    const handleResetWhatsApp = async () => {
        try {
            await fetch(`${Url.Url}/reset-one/${userId}`, { method: 'POST' });

            setQrImage(null);
            setWaReady(false);
            setQrMessage('♻️ Session reset. Starting new session...');
            setPolling(true); // Re-check for new QR

            // 🚨 Immediately start session and fetch QR
            await fetch(`${Url.Url}/start-whatsapp/${userId}`, { method: 'POST' });
            fetchQr(); // Force fetch after reset
        } catch (error) {
            console.error('❌ Reset failed:', error);
            setQrMessage('Failed to reset WhatsApp session.');
        }
    };
    



    // Sends WhatsApp messages using selected templates to filtered recipients
    const handleSendFromBackend = async () => {
        // Validation: Ensure at least one template is selected
        if (selectedTemplates.length === 0) {
            setStatus('❌ Please select at least one template.');
            return;
        }

        // Validation: Ensure there are recipients based on filter
        if (filteredData.length === 0) {
            setStatus('❌ No recipients available in the selected status.');
            return;
        }

        // Set UI state before sending begins
        setSending(true);
        setStatus('');
        setShowTemplateModal(false);

        // Prepare mobile numbers for sending
        const numbers = filteredData.map(item => item.Mobile || item.mobile);

        // Initialize tracking variables
        let messagesFromServer = [];  // Collect server responses for display
        let localSent = [];           // Successfully sent numbers
        let failedNumbers = [];       // Failed numbers

        // Loop through each selected template and recipient number
        for (const template of selectedTemplates) {
            for (const number of numbers) {
                try {
                    const response = await axios.post(`${Url.Url}/send-bulk-whatsapp/${userId}`, {
                        numbers: [number], // Send one number at a time
                        message: template.message
                    });

                    const res = response.data;

                    const sentList = res.success || [];
                    const failedList = res.failed || [];

                    // Add success messages
                    sentList.forEach(msg => {
                        messagesFromServer.push(msg);
                        const mobile = msg.split(':');
                        localSent.push(mobile);
                        setSentNumbers(prev => Array.from(new Set([...prev, mobile])));
                    });

                    // Add failed messages
                    failedList.forEach(f => {
                        messagesFromServer.push(`${f.mobile}: ${f.error}`);
                        failedNumbers.push(f.mobile);
                    });

                } catch (err) {
                    console.error('Error:', err);
                    messagesFromServer.push(`${number}: ❌ Network or API error`);
                    failedNumbers.push(number);
                }
                
                // try {
                //     // Send message via backend API
                //     const response = await axios.post(`${Url.Url}/send-bulk-whatsapp/${userId}`, {

                //         numbers: [number], // Send one number at a time
                //         message: template.message
                //     });

                //     const res = response.data;
                //     const messageText = res.message?.toLowerCase() || '';

                //     // Save server response for logging
                //     messagesFromServer.push(`${number}: ${res.message || 'No message'}`);

                //     // Determine if message was successfully sent
                //     const isSuccess = messageText.includes('success') || messageText.includes('✅') || res.status === 'success';
                //     if (isSuccess) {
                //         localSent.push(number);
                //         setSentNumbers(prev => Array.from(new Set([...prev, number]))); // Avoid duplicates
                //     } else {
                //         failedNumbers.push(number);
                //     }

                // } catch (err) {
                //     // Catch and log any API or network errors
                //     messagesFromServer.push(`${number}: error`);
                //     failedNumbers.push(number);
                // }
            }
        }

        // Display final status based on results
        if (failedNumbers.length === 0) {
            setStatus(`✅ All messages sent successfully.\n${messagesFromServer.join(' | ')}`);
        } else if (localSent.length > 0) {
            setStatus(`⚠️ Some messages sent.\n${messagesFromServer.join(' | ')}\n❌ Failed: ${failedNumbers.join(', ')}`);
        } else {
            setStatus(`❌ All messages failed.\n${messagesFromServer.join(' | ')}`);
        }

        // Reset sending state
        setSending(false);
    };

    const [selectedPDF, setSelectedPDF] = useState(null);

    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
    const acceptTypes = allowedExtensions.join(','); // ".pdf,.jpg,.jpeg,.png"
    

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) {
            setSelectedPDF(null); // or setSelectedFile(null) if you rename it
            return;
        }

        const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

        if (allowedExtensions.includes(fileExtension)) {
            setSelectedPDF(file); // rename to setSelectedFile if you're sending image too
        } else {
            alert("❌ Invalid file type. Please select a PDF or image file (PDF, JPG, JPEG, PNG).");
            setSelectedPDF(null);
        }
    };
    

    const handleSendPDF = async () => {
        if (!selectedPDF) {
            setStatus("❌ Please select a  file.");
            return;
        }

        if (filteredData.length === 0) {
            setStatus("❌ No recipients available in the selected status.");
            return;
        }

        setSending(true);
        setStatus("");

        const numbers = filteredData.map(item => item.Mobile || item.mobile);
        const formData = new FormData();
        formData.append("file", selectedPDF);
        formData.append("numbers", JSON.stringify(numbers));
        try {
            const response = await axios.post(
                `${Url.Url}/send-bulk-media/${userId}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const res = response.data;
            const allMessages = [];

            const successNumbers = res.success || [];
            const failedObjects = res.failed || [];

            // Collect display strings
            allMessages.push(...successNumbers);
            const failedMessages = failedObjects.map(f => `${f.mobile}: ${f.error}`);
            allMessages.push(...failedMessages);

            const successMobileNumbers = successNumbers.map(msg => msg.split(':'));
            const failedMobileNumbers = failedObjects.map(f => f.mobile);

            // Update sent list
            setSentNumbers(prev => Array.from(new Set([...prev, ...successMobileNumbers])));

            if (failedMobileNumbers.length === 0) {
                setStatus(`✅ All files sent successfully.\n${allMessages.join(' | ')}`);
            } else if (successMobileNumbers.length > 0) {
                setStatus(`⚠️ Some files sent.\n${allMessages.join(' | ')}\n❌ Failed: ${failedMobileNumbers.join(', ')}`);
            } else {
                setStatus(`❌ All failed.\n${allMessages.join(' | ')}`);
            }

        } catch (error) {
            console.error(error);
            setStatus("❌ Error while sending file.");
        }
        

        // try {
        //     const response = await axios.post(
        //         `${Url.Url}/send-bulk-media/${userId}`,
        //         formData,
        //         { headers: { "Content-Type": "multipart/form-data" } }
        //     );

        //     const res = response.data;
        //     const allMessages = res.result || [];

        //     const failedNumbers = allMessages.filter(m => m.includes("❌")).map(m => m.split(":"));
        //     const successNumbers = allMessages.filter(m => m.includes("✅")).map(m => m.split(":"));

        //     setSentNumbers(prev => Array.from(new Set([...prev, ...successNumbers])));

        //     if (failedNumbers.length === 0) {
        //         setStatus(`✅ All PDFs sent successfully.\n${allMessages.join(' | ')}`);
        //     } else if (successNumbers.length > 0) {
        //         setStatus(`⚠️ Some PDFs sent.\n${allMessages.join(' | ')}\n❌ Failed: ${failedNumbers.join(', ')}`);
        //     } else {
        //         setStatus(`❌ All PDFs failed.\n${allMessages.join(' | ')}`);
        //     }

        // } catch (error) {
        //     console.error(error);
        //     setStatus("❌ Error while sending PDF.");
        // }

        setSending(false);
    };
    const [qrLoading, setQrLoading] = useState(false);
    const [qrError, setQrError] = useState('');
    const fetchQrOnce = async () => {
        setQrLoading(true);
        setQrError('');
        setQrImage(null);
        setWaReady(false);
        setQrMessage('');
        try {
            const res = await fetch(`${Url.Url}/whatsapp-qr/${userId}`);
            const data = await res.json();
            if (data.qr) {
                setQrImage(data.qr);
                setWaReady(false);
            } else if (data.ready) {
                setWaReady(true);
                setQrImage(null);
            }
            if (data.message) setQrMessage(data.message);
        } catch (err) {
            setQrError('❌ Failed to fetch QR code.');
        }
        setQrLoading(false);
    };

 

    const handleTemplateToggle = (template) => {
        setSelectedTemplates(prev =>
            prev.some(t => t.id === template.id)
                ? prev.filter(t => t.id !== template.id)
                : [...prev, template]
        );
    };

    useEffect(() => {
        if (activeStatus === 'All') {
            setFilteredData(data);
        } else {
            setFilteredData(data.filter(item => (item.Status || 'No Status') === activeStatus));
        }
    }, [activeStatus, data]);

    // Offcanvas styles
    const canvasStyles = {
        position: 'fixed',
        top: 0,
        right: 0,
        width: '350px',
        height: '100%',
        background: '#fff',
        boxShadow: '-2px 0 10px rgba(0,0,0,0.2)',
        zIndex: 2000,
        transform: showOffcanvas ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.3s',
        display: 'flex',
        flexDirection: 'column'
    };

    const overlayStyles = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.2)',
        zIndex: 1999,
        display: showOffcanvas ? 'block' : 'none'
    };
    // Memoized status counts for tabs
    const statusCounts = useMemo(() => {
        const counts = { 'All': data.length };
        data.forEach(item => {
            const status = item.Status || 'No Status';
            counts[status] = (counts[status] || 0) + 1;
        });
        return counts;
    }, [data]);
    const handleSendAll = async () => {
        if (selectedTemplates.length === 0 && !selectedPDF) {
            setStatus("❌ Please select template or file.");
            return;
        }

        if (filteredData.length === 0) {
            setStatus("❌ No recipients available.");
            return;
        }

        setSending(true);
        setStatus("");

        try {
            if (selectedTemplates.length > 0) {
                await handleSendFromBackend();
            }

            if (selectedPDF) {
                await handleSendPDF();
            }

            setStatus("✅ All selected actions completed.");

            // ✅ CLEAR AFTER SEND (IMPORTANT)
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setSelectedTemplates([]);
            setSelectedPDF(null);

        } catch (err) {
            console.error(err);
            setStatus("❌ Error while sending.");
        }

        setSending(false);
    };
    const fileInputRef = useRef(null);
    return (
        <div>
            {/* Offcanvas overlay and panel */}
            {showOffcanvas && <div style={overlayStyles} onClick={() => setShowOffcanvas(false)} />}
            <div style={canvasStyles}>
                <div style={{ padding: 24, borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, fontWeight: 600, fontSize: 20 }}>WhatsApp Status</h3>
                    <button onClick={() => setShowOffcanvas(false)} style={{ fontSize: 22, background: 'none', border: 'none', cursor: 'pointer' }}>&times;</button>
                </div>
                <div style={{ padding: 24, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    {waReady ? (
                        <>
                            <div style={{ color: '#25D366', fontWeight: 'bold', fontSize: 18, marginBottom: 16 }}>WhatsApp Connected</div>
                            <button
                                onClick={handleResetWhatsApp}
                                style={{
                                    background: '#ff4d4f',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: 6,
                                    padding: '10px 24px',
                                    fontWeight: 600,
                                    fontSize: 16,
                                    cursor: 'pointer',
                                    marginBottom: 10
                                }}
                            >
                                Reset WhatsApp
                            </button>
                        </>
                    ) : (
                        <>
                            {qrLoading ? (
                                <div style={{ margin: '30px 0' }}>Loading QR...</div>
                            ) : (
                                qrImage ? (
                                    <img src={qrImage} alt="WhatsApp QR" style={{ width: 220, height: 220, margin: '20px 0', borderRadius: 12, boxShadow: '0 2px 12px #eee' }} />
                                ) : (
                                    <div style={{ margin: '30px 0', color: '#888' }}>Scan QR to connect WhatsApp</div>
                                )
                            )}
                            {qrMessage && <div style={{ color: '#888', marginBottom: 10 }}>{qrMessage}</div>}
                            <button
                                onClick={fetchQrOnce}
                                style={{
                                    background: '#25D366',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: 6,
                                    padding: '10px 24px',
                                    fontWeight: 600,
                                    fontSize: 16,
                                    cursor: 'pointer',
                                    marginBottom: 10
                                }}
                            >
                                Set WhatsApp
                            </button>
                        </>
                    )}
                </div>
            </div>

            {/* Main UI */}
            {waReady ? (
                <div className="autosend-top-bar">

                    {/* LEFT */}
                    <div className="autosend-left-controls">

                        {/* WhatsApp Template */}
                        <button
                            className="autosend-btn"
                            onClick={() => setShowTemplateModal(true)}
                            disabled={sending}
                        >
                            <i className="fa fa-whatsapp" />
                            {selectedTemplates.length > 0
                                ? `${selectedTemplates.length} Selected`
                                : 'Select WhatsApp Message'}
                        </button>

                        {/* File */}
                        <label className="autosend-file-box">
                            <i className="fa fa-paperclip" />
                            <span>
                                {selectedPDF ? selectedPDF.name : 'Select File'}
                            </span>
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept={acceptTypes}
                                onChange={handleFileChange}
                            />
                        </label>

                    </div>

                    {/* SINGLE SEND BUTTON */}
                    <button
                        className="autosend-send-btn"
                        onClick={handleSendAll}
                        disabled={sending}
                    >
                        <i className="fa fa-paper-plane" />
                        {sending ? 'Sending...' : 'Send'}
                    </button>

                </div>
            ) : (
                <div
                    style={{
                        backgroundColor: '#f3f4f6',
                        padding: '14px 20px',
                        borderRadius: '8px',
                        color: '#374151',
                        fontSize: '15px',
                        fontWeight: '500',
                        marginBottom: '20px',
                        maxWidth: '650px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}
                >
                    ⚠️ Please connect your device using the WhatsApp mobile app to continue.
                </div>
            )}


            {/* {status && <p style={{ fontWeight: 'bold', whiteSpace: 'pre-line' }}>{status}</p>} */}
            <div className="autosend-status-tabs-scroll">
                <div className="autosend-status-tabs">
                    {statuses.map(tab => (
                        <button
                            key={tab}
                            className={`autosend-status-tab-button${activeStatus === tab ? ' active' : ''}`}
                            onClick={() => setActiveStatus(tab)}
                            tabIndex={0}
                        >
                            <span className={`autosend-status-tab-count${activeStatus === tab ? ' active' : ''}`}>{statusCounts[tab] || 0}</span>
                            <span className="autosend-status-tab-label">{tab}</span>
                        </button>
                    ))}
                </div>
            </div>

            <div className="autosend-card-grid">
                {filteredData.map((item, index) => {
                    const mobile = item.Mobile || item.mobile;
                    return (
                        <div
                            key={index}
                            className={`autosend-card-gradient status-${(item.Status || 'no-status').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                        >
                            <div className={`autosend-card-status-badge status-badge-${(item.Status || 'no-status').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
                                {item.Status || 'No Status'}
                            </div><br/>
                            <p><strong>Company:</strong> {item.CompanyName}</p>
                            <p><strong>Name:</strong> {item.ContactPerson}</p>
                            <p><strong>Mobile:</strong> {mobile}</p>
                            {item.Email && <p><strong>Email:</strong> {item.Email}</p>}
                            {item.ProductName && <p><strong>Product:</strong> {item.ProductName}</p>}
                            {item.LeadSource && <p><strong>Lead Source:</strong> {item.LeadSource}</p>}
                            {sentNumbers.includes(mobile) && (
                                <p style={{ color: 'green', fontWeight: 'bold' }}>Successfully sent</p>
                            )}
                        </div>
                    );
                })}
            </div>

            {showTemplateModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            background: 'white',
                            borderRadius: 12,
                            padding: 20,
                            width: '90vw',
                            maxWidth: 1000,
                            height: '80vh',
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                        }}
                    >
                        {/* Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                            <h3 style={{ margin: 0, fontSize: 20, color: '#0a4f88' }}>Select WhatsApp Template</h3>
                            <button
                                onClick={() => setShowTemplateModal(false)}
                                style={{
                                    fontSize: 24,
                                    background: 'none',
                                    border: 'none',
                                    color: '#888',
                                    cursor: 'pointer',
                                }}
                            >
                                &times;
                            </button>
                        </div>

                        {/* Tabs/Filters */}
                        <div style={{ display: 'flex', gap: 10, overflowX: 'auto', marginBottom: 15 }}>
                            {statusTemplateTabs.map(tab => (
                                <button
                                    key={tab}
                                    onClick={() => setTemplateTab(tab)}
                                    style={{
                                        padding: '6px 14px',
                                        borderRadius: 6,
                                        border: '1px solid #0a4f88',
                                        background: templateTab === tab ? '#0a4f88' : '#fff',
                                        color: templateTab === tab ? '#fff' : '#0a4f88',
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>

                        {/* Main Section: Template List + Preview */}
                        <div style={{ flex: 1, display: 'flex', gap: 20, overflow: 'hidden' }}>
                            {/* Template List */}
                            <div style={{ flex: 1, overflowY: 'auto', paddingRight: 10 }}>
                                {loadingWhatsappTemplates && <p>Loading templates...</p>}
                                {whatsappTemplateError && <p style={{ color: 'red' }}>{whatsappTemplateError}</p>}
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {filteredTemplates.map(template => (
                                        <li key={template.id} style={{ marginBottom: 8 }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedTemplates.some(t => t.id === template.id)}
                                                onChange={() => handleTemplateToggle(template)}
                                                style={{ display: 'none' }}
                                            />
                                            <button
                                                onClick={() => handleTemplateToggle(template)}
                                                style={{
                                                    padding: '10px 12px',
                                                    borderRadius: 6,
                                                    backgroundColor: selectedTemplates.some(t => t.id === template.id)
                                                        ? '#0a4f88'
                                                        : '#f2f2f2',
                                                    color: selectedTemplates.some(t => t.id === template.id) ? 'white' : '#333',
                                                    border: '1px solid #ccc',
                                                    width: '100%',
                                                    textAlign: 'left',
                                                    fontWeight: 500,
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {template.templtname}
                                            </button>
                                        </li>
                                    ))}
                                    {!loadingWhatsappTemplates && filteredTemplates.length === 0 && (
                                        <li style={{ color: '#888' }}>No templates found for this category.</li>
                                    )}
                                </ul>
                            </div>

                            {/* Preview Messages */}
                            <div style={{ flex: 1.2, overflowY: 'auto' }}>
                                {selectedTemplates.length > 0 ? (
                                    <>
                                        {selectedTemplates.map(t => (
                                            <div key={t.id} style={{ marginBottom: 16 }}>
                                                <div style={{ fontWeight: 600, marginBottom: 4 }}>{t.templtname}</div>
                                                <textarea
                                                    value={t.message}
                                                    readOnly
                                                    rows={15}
                                                    style={{
                                                        width: '100%',
                                                        padding: 10,
                                                        borderRadius: 6,
                                                        border: '1px solid #ccc',
                                                        resize: 'none',
                                                        background: '#f8f8f8',
                                                        fontSize: 14,
                                                        fontFamily: 'monospace',
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <p style={{ color: '#888' }}>No template selected</p>
                                )}
                            </div>
                        </div>

                        {/* Footer Buttons */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                            <button
                                onClick={() => setShowTemplateModal(false)}
                                style={{
                                    marginRight: 12,
                                    padding: '8px 18px',
                                    borderRadius: 6,
                                    background: '#ccc',
                                    border: 'none',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => setShowTemplateModal(false)}
                                disabled={loadingWhatsappTemplates}
                                style={{
                                    padding: '8px 18px',
                                    borderRadius: 6,
                                    background: '#0a4f88',
                                    color: 'white',
                                    fontWeight: 600,
                                    border: 'none',
                                    cursor: 'pointer',
                                }}
                            >
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}